import React, { useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { LOGIN_VIEW_LABELS } from '../resources/labels.json'
import { AgeButton, CountryCode, Label, PhoneInput } from '../theme'

const {
  INPUT_NUMBER_LABEL,
  INPUT_NUMBER_LABEL2,
  INPUT_ERROR,
  TITLE,
  SUBMIT_BUTTON,
  TERMSANDCONDITION,
} = LOGIN_VIEW_LABELS

// const LOGIN_WITH = 'Or Login With'
// const ENTER_NUMBER = 'Enter Your Mobile Number'
// const SUBMIT = 'Submit'

function PhoneLoginForm(props) {
  const { onSubmit } = props
  const [validated, setValidated] = useState(false)
  const [show, setShow] = useState(false)
  const [number, setNumber] = useState('')
  const [validationfail, setVaildationFAil] = useState(false)

  const handleSubmit = (event) => {
    event.preventDefault()
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      setVaildationFAil(true)
      event.stopPropagation()
    } else {
      const { phoneNumberEl } = form.elements
      const number = phoneNumberEl.value
      setNumber(number)
      onSubmit(number)
      window.sendEvent({
        type: 'OB_ADD_PHONE_NO',
        data: { screen: 'Onboarding' },
      })
    }
    setValidated(true)
  }

  return (
    <>
      <div>
        <p style={{ fontSize: '20px', textAlign: 'center' }} className="font">
          {TERMSANDCONDITION}
        </p>
        <div className="d-flex justify-content-around mt-4">
          <AgeButton
            className="font"
            borderradius="10px"
            block
            bgcolor={show ? 'white' : '#ff8d85'}
            color={show ? 'black' : 'white'}
            padding={'10px 25px'}
            onClick={() => setShow(false)}
          >
            असहमत
          </AgeButton>
          <AgeButton
            className="font"
            borderradius="10px"
            block
            bgcolor={show ? '#009B4D' : 'white'}
            color={show ? 'white' : 'black'}
            padding={'10px 25px'}
            onClick={() => setShow(true)}
          >
            सहमत
          </AgeButton>
        </div>
        {/* <Label className="pt-2">{INPUT_NUMBER_LABEL2}</Label> */}
      </div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row className="d-flex align-items-center justify-content-center">
          <Form.Group
            className="d-flex align-items-center "
            as={Col}
            xs="10"
            controlId="validationCustom03"
            style={{ backgroundColor: '#FFF3C6', borderRadius: '5px' }}
          >
            <CountryCode xs="3" className="m-0 px-0">
              <span
                style={{ height: '100%', fontSize: '20px', fontWeight: '300' }}
                className="d-flex align-items-center justify-content-center p-2"
              >
                +91-
              </span>
            </CountryCode>
            <PhoneInput
              className="phoneNumberInput m-0 col-9 p-2"
              style={{ backgroundColor: '#FFF3C6', textAlign: 'left' }}
              width={11}
              xs="9"
              required
              maxLength="10"
              type="number"
              name="phoneNumberEl"
              pattern="[6789][0-9]{9}"
              value={number}
              onChange={(e) =>
                e.target.value.length < 11 && setNumber(e.target.value)
              }
            />
          </Form.Group>
          <p style={{ color: 'red' }}>{validationfail ? INPUT_ERROR : ''}</p>
        </Form.Row>

        <AgeButton
          className="pt-3"
          className="font"
          disabled={!show}
          block
          type="submit"
          bgcolor={!show ? 'grey' : '#009B4D'}
          color={'white'}
          padding={'10px 25px'}
          borderradius="10px"
        >
          {SUBMIT_BUTTON}
        </AgeButton>
      </Form>
    </>
  )
}

export default PhoneLoginForm
